import { TranslationPipe } from 'src/shared/pipes/translation.pipe';

const TASK_STATUS_LABELS: Record<string, string> = {
  'reported': 'New',
  'approved': 'Approved',
  'in_progress': 'Doing',
  'done': 'Done'
};

export function getTaskStatusLabel(status: string): string {
  const label = TASK_STATUS_LABELS[status] || status;
  return new TranslationPipe().transform(label);
}
